
import { defineComponent, onMounted, watch } from 'vue';
import FarmerRewardDisplay from '@/components/gem-farm/FarmerRewardDisplay2.vue';
import useWallet from '@/composables/wallet';
import useCluster from '@/composables/cluster';
import { initGemFarm } from '@/common/gem-farm';
import { PublicKey } from '@solana/web3.js';
import { parseDate } from '@/common/util';
import { useLoading } from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { createToaster } from "@meforma/vue-toaster";

export default defineComponent({
  components: { FarmerRewardDisplay },
  props: {
    farm: String,
    farmAcc: Object,
    farmer: String,
    farmerAcc: Object,
  },
  emits: ['refresh-farmer'],
  setup(props, ctx) {
    const { wallet, getWallet } = useWallet();
    const { cluster, getConnection } = useCluster();
    const $loading = useLoading();
    let gf: any;
    watch([wallet, cluster], async () => {
      gf = await initGemFarm(getConnection(), getWallet()!);
    });

    //need an onmounted hook because this component isn't yet mounted when wallet/cluster are set
    onMounted(async () => {
      if (getWallet() && getConnection()) {
        let loader = $loading.show({})
        try{

          gf = await initGemFarm(getConnection(), getWallet()!);
        }
        catch(e){
          loader.hide()

        }
        createToaster({}).show("Loaded!",{type:"success"})

        loader.hide()
      }
    });

    // --------------------------------------- display farmer
    // todo ideally should be using one from client, but n/a during render
    const parseFarmerState = (farmer: any): string => {
      return Object.keys(farmer.state)[0];
    };

    const refreshFarmer = async () => {
      let loader = $loading.show({})

      try{

        await gf.refreshFarmerWallet(
          new PublicKey(props.farm!),
        new PublicKey(props.farmer!)
        );

      }
      catch(e){
        loader.hide()
        createToaster({}).show("Error! Please try again.",{type:"error"})
        
      }
      createToaster({}).show("Refresh Done!",{type:"success"})

      loader.hide()
      ctx.emit('refresh-farmer');
    };

    return {
      refreshFarmer,
      parseFarmerState,
      parseDate,
    };
  },
});
